var m = Object.defineProperty;
var C = (r, n, t) => n in r ? m(r, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[n] = t;
var o = (r, n, t) => (C(r, typeof n != "symbol" ? n + "" : n, t), t);
import a, { Component as g } from "react";
import e from "prop-types";
import { smoothDnD as p, dropHandlers as y, constants as O } from "@smooth-dnd/core";
export * from "@smooth-dnd/core";
p.dropHandler = y.jsxDropHandler().handler;
p.wrapChild = !1;
class u extends g {
  constructor(t) {
    super(t);
    o(this, "prevContainer");
    o(this, "container", null);
    o(this, "containerRef", a.createRef());
    this.getContainerOptions = this.getContainerOptions.bind(this), this.getContainer = this.getContainer.bind(this), this.isObjectTypePropsChanged = this.isObjectTypePropsChanged.bind(this), this.prevContainer = null;
  }
  componentDidMount() {
    this.prevContainer = this.getContainer(), this.container = p(this.getContainer(), this.getContainerOptions());
  }
  componentWillUnmount() {
    this.container.dispose(), this.container = null;
  }
  componentDidUpdate(t) {
    if (this.getContainer()) {
      if (this.prevContainer && this.prevContainer !== this.getContainer()) {
        this.container.dispose(), this.container = p(this.getContainer(), this.getContainerOptions()), this.prevContainer = this.getContainer();
        return;
      }
      this.isObjectTypePropsChanged(t) && this.container.setOptions(this.getContainerOptions());
    }
  }
  isObjectTypePropsChanged(t) {
    const { render: l, style: i, ...s } = this.props;
    for (const c in s) {
      const h = c;
      if (s.hasOwnProperty(h)) {
        const d = s[h];
        if (typeof d != "function" && d !== t[h])
          return !0;
      }
    }
    return !1;
  }
  render() {
    return this.props.render ? this.props.render(this.containerRef) : /* @__PURE__ */ a.createElement("div", { style: this.props.style, ref: this.containerRef }, this.props.children);
  }
  getContainer() {
    return this.containerRef.current;
  }
  getContainerOptions() {
    return Object.keys(this.props).reduce((t, l) => {
      const i = l, s = this.props[i];
      return typeof s == "function" ? t[i] = (...c) => this.props[i](...c) : t[i] = s, t;
    }, {});
  }
}
o(u, "propTypes", {
  behaviour: e.oneOf(["move", "copy", "drop-zone", "contain"]),
  groupName: e.string,
  orientation: e.oneOf(["horizontal", "vertical"]),
  style: e.object,
  dragHandleSelector: e.string,
  nonDragAreaSelector: e.string,
  dragBeginDelay: e.number,
  animationDuration: e.number,
  autoScrollEnabled: e.bool,
  lockAxis: e.string,
  dragClass: e.string,
  dropClass: e.string,
  onDragStart: e.func,
  onDragEnd: e.func,
  onDrop: e.func,
  getChildPayload: e.func,
  shouldAnimateDrop: e.func,
  shouldAcceptDrop: e.func,
  onDragEnter: e.func,
  onDragLeave: e.func,
  render: e.func,
  getGhostParent: e.func,
  removeOnDropOut: e.bool,
  dropPlaceholder: e.oneOfType([
    e.shape({
      className: e.string,
      animationDuration: e.number,
      showOnTop: e.bool
    }),
    e.bool
  ])
}), o(u, "defaultProps", {
  behaviour: "move",
  orientation: "vertical"
});
const { wrapperClass: f } = O;
class b extends g {
  render() {
    if (this.props.render)
      return a.cloneElement(this.props.render(), { className: f });
    const n = `${this.props.className ? this.props.className + " " : ""}`;
    return /* @__PURE__ */ a.createElement("div", { ...this.props, className: `${n}${f}` }, this.props.children);
  }
}
o(b, "propsTypes", {
  render: e.func,
  className: e.string
});
export {
  u as Container,
  b as Draggable
};
